import React, { createContext, useContext, useState } from "react";

export const QueryContext = createContext();

export const useQueryContext = () => useContext(QueryContext);

export const QueryContextProvider = (props) => {
  const [state, setState] = useState({
    loadingPrecatorio: false,
    orderBy: [],
    pagination: {
      loadingNext: false,
      present: false,
      currentPage: 1,
      totalRecords: 0,
      totalPages: 0,
      perPage: 10,
    },
    params: {},
    selectedCourts: {
      data: [],
    },
    queryStatus: "idle",
  });

  return (
    <QueryContext.Provider
      value={{
        ...state,
        backToTable: () => {
          setState((oldState) => ({ ...oldState, precatorioId: undefined }));
        },
        setNewOrder: (orderBy) => {
          setState((oldState) => ({ ...oldState, orderBy }));
        },
        loadedPrecatorio: () => {
          setState((oldState) => ({ ...oldState, loadingPrecatorio: false }));
        },
        updateParams: (params) => {
          setState((oldState) => ({
            ...oldState,
            params,
          }));
        },
        setResult: ({ pagy, quota_usage, precatorios }) => {
          const { data } = precatorios;
          const { page, next, prev, last, count, pages } = pagy;

          setState((oldState) => ({
            ...oldState,
            loadingPrecatorio: false,
            precatorios: data,
            quotaUsage: quota_usage,
            precatorioId: null,
            pagination: {
              ...state.pagination,
              present: data.length > 0,
              currentPage: page,
              nextPage: next,
              previousPage: prev,
              lastPage: last,
              totalRecords: count,
              totalPages: pages,
            },
            queryStatus: "success",
          }));
        },
        updateSelectedCourts: (selectedCourts) => {
          setState((oldState) => ({
            ...oldState,
            selectedCourts,
          }));
        },
        selectPrecatorio: (precatorioId) => {
          setState((oldState) => ({
            ...oldState,
            precatorioId,
            loadingPrecatorio: true,
          }));
        },
        setNewPage: (currentPage) => {
          setState((oldState) => ({
            ...oldState,
            loadingPrecatorio: false,
            pagination: {
              ...state.pagination,
              currentPage,
            },
          }));
        },
        setPerPage: (perPage) => {
          setState((oldState) => ({
            ...oldState,
            loadingPrecatorio: false,
            pagination: {
              ...state.pagination,
              perPage,
              currentPage: 1,
            },
          }));
        },
        updateStatus: (queryStatus) => {
          setState((oldState) => ({ ...oldState, queryStatus }));
        },
      }}
    >
      {props.children}
    </QueryContext.Provider>
  );
};
